import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class TaxCodeForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }
  
  private viewGet(): CerFormView {
    
    const view = new CerFormView();
    view.viewMetadata = {
      name: 'tax-code', dataApiName: 'FinanceTaxCode', text: 'Momskoder', textSingular: 'Momskode',
      primaryKey: 'num', titleFields: ['num', 'name'], baseFields: ['id', 'num', 'name'],
      allowCreate: false, allowEdit: false, allowDelete: false
    };

    view.fieldMetadata = [
      { name: 'rate', text: 'Sats', format: 'AmountPct'}
    ];

    return view;
  }
}
